const RANKS_FEATURES = {
  fields: {
    creatorAvatar: true,
  },
};

export function isFieldEnabled(id) {
  return RANKS_FEATURES.fields[id] !== false;
}

export function setRanksFeatures(overrides) {
  if (overrides.fields) {
    Object.assign(RANKS_FEATURES.fields, overrides.fields);
  }
}

export function resetRanksFeatures() {
  RANKS_FEATURES.fields.creatorAvatar = true;
}
